/** Card-holder/employee names come back from the backend in ALL CAPS (bank card-printing
 * convention). Normalize to Title Case for display rather than showing them shouting. */
export function toTitleCase(name: string): string {
  return name
    .toLowerCase()
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
